import { QueryClient } from 'react-query';
import {
  IClickToCallConfigurations,
  IClickToCallConfigurationsCMS,
  IGetClickToCallData,
} from './clicktocall.models';
import { openPopup, volaModalManager, AppMobile, ITrackError } from '@vfit/shared/data-access';
import { SoftManagerService } from '@vfit/consumer/providers';
import { IActionSlide, IClickToCallMeData } from '@vfit/shared/models';
import { IProduct } from '../../api/products/products.models';

const getClickToCallUrl = (
  ctcConfiguration: IClickToCallConfigurations,
  product?: IProduct,
  step?: string,
  error?: ITrackError
): string => {
  let clickToCallUrl;
  try {
    clickToCallUrl = new URL(ctcConfiguration?.url);
  } catch (e) {
    return '';
  }
  const { description: forcedDescription } = ctcConfiguration;
  const isOverrideDesc = ctcConfiguration?.overrideDesc === 'true';

  if (isOverrideDesc)  {
    const env = AppMobile.checkIsApp() ? 'app' : 'web';
    const icmp = new URLSearchParams(location?.search).get('icmp') || 'landing-page';
    const sessionIcmp = sessionStorage?.getItem('icmp');
    const userType = 'NEXT';
    const origin = icmp || sessionIcmp ? 'ORG' : 'ADV';
    const pathname = location?.pathname?.replace(/^\//, '').replace(/\//g, '-');
    const fullPathname = step ? `${pathname}-${step}` : pathname;
    let autoUrl = `${env}_${icmp}_${userType}_${origin}_${fullPathname}`;

    if (error?.errorCode || error?.error?.status) {
      autoUrl = `${autoUrl}_error_${error?.errorCode || error?.error?.status}`;
    }
    if (product) {
      const productName = product?.title?.replace(/\s+/g, '-');
      const productId = product?.offerId;
      const productPrice = product?.price?.replace(/[^0-9,]/g, '').replace(',', '');
      autoUrl = `${autoUrl}_${productName}_${productId}_${productPrice}`;
    }

    if (forcedDescription) {
      autoUrl = `${autoUrl}_${forcedDescription.replace(/\s+/g, '-')}`
    }

    clickToCallUrl.searchParams.set('DESC', autoUrl);

  }

  return clickToCallUrl.toString() || '';
};

const getClickToCallUrlByActionType = (actionType: IActionSlide, product?: IProduct): string => {
  return getClickToCallUrl(
    {
      url: actionType?.url || '',
      template: actionType?.template || '',
      overrideDesc: actionType?.overrideDesc || 'false',
      description: actionType?.description || '',
    },
    product
  );
};

export const getCtcSunriseTemplate = (templateKey?: string, queryClient?: QueryClient) => {
  const cmsVolaTemplates = queryClient.getQueryData('getVolaTemplates');
  return (cmsVolaTemplates?.[templateKey] || {}) as IClickToCallMeData;
};

const getClickToCall = (queryClient: QueryClient, clickToCallData?: IGetClickToCallData) => {
  const {
    idClickToCall,
    clickToCallOverrideConfiguration,
    productOverrideConfiguration,
    product,
    taggingSunriseCtc,
  } = clickToCallData || {};
  const productType = product?.category || '';

  const cmsCommonApiKey =
    productType === 'fixed'
      ? 'getClickToCallFixedLineConfigurations'
      : 'getClickToCallMobileLineConfigurations';

  const cmsCommonApi = queryClient?.getQueryData?.(
    cmsCommonApiKey
  ) as IClickToCallConfigurationsCMS;
  const volaClickToCallData = queryClient?.getQueryData(
    'getClickToCallConfigurations'
  ) as IClickToCallMeData;

  const findConfiguration = (configurations: any[], key: string) =>
    configurations.find((ctcConf) => ctcConf?.key?.toLowerCase() === key?.toLowerCase());

  const productConfiguration = findConfiguration(
    productOverrideConfiguration?.clicktocallconfigura?.elements || [],
    idClickToCall
  );
  const commonConfiguration = findConfiguration(
    cmsCommonApi?.clicktocallconfigura?.elements || [],
    idClickToCall
  );

  const configuration: IClickToCallConfigurations =
    clickToCallOverrideConfiguration || productConfiguration || commonConfiguration;

  if (configuration?.type) {
    switch (configuration.type) {
      case 'CTC_IFRAME':
        openPopup(getClickToCallUrl(configuration));
        break;
      case 'CTC_SUNRISE':
        const templateData = getCtcSunriseTemplate(configuration?.template, queryClient);
        volaModalManager.handleVolaModal({
          url: getClickToCallUrl(configuration),
          cmsClickToCallData: configuration?.template
            ? { ...templateData }
            : { ...volaClickToCallData },
          ...(taggingSunriseCtc && { taggingOption: taggingSunriseCtc }),
          pageProduct: SoftManagerService(queryClient).getPageProduct(product),
        });
        break;
      default:
        break;
    }
  }
};

export { getClickToCallUrl, getClickToCallUrlByActionType, getClickToCall };
